export const overOverlayModalClass = 'over-overlay-modal';
export const overOverlayModalBackdropClass = 'over-overlay-modal-backdrop';
